import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { toastSuccess } from 'ui/partials/Toast';
import { useProvider } from 'utils/providers/Provider';
import useModal from 'ui/partials/Modal/useModal';
import { useAdminParams } from 'utils/helpers';
import partialConstants from 'ui/partials/utils/constants';

import c from '../utils/constants';
import { MULTI_DEALS_EDIT_FORM } from '../forms/schema';

interface Payload extends MULTI_DEALS_EDIT_FORM {
  ids: string[];
}

export default function useUpdateDeals() {
  const queryClient = useQueryClient();
  const { hideModal } = useModal();
  const { accountId, accountUserId } = useAdminParams();
  const { state } = useProvider();
  const args = state;

  return useMutation({
    mutationFn: async (payload: Payload) => {
      const api = new Api(args);

      const data = await api.patch(
        await withAcl({
          account: {
            url: `api/v1/sales/deals`,
            payload,
          },
          admin: {
            url: `/api/v2/accounts/${accountId}/users/${accountUserId}/sales/deals`,
            payload,
          },
        }),
      );

      return data;
    },
    onSuccess: (_, payload) => {
      payload.ids.forEach((id) => {
        queryClient.invalidateQueries({
          queryKey: [c.PIPELINES, c.DEALS, id],
        });
      });

      queryClient.invalidateQueries({
        queryKey: [c.DEALS],
      });
      queryClient.invalidateQueries({
        queryKey: [partialConstants.TAGS],
      });

      toastSuccess('Successfully updated deals');
      hideModal();
    },
  });
}
